module.exports = __webpack_public_path__ + "static/3-5715582e9c82e623817dc9776c64c719.jpg";